import { makeStyles, Theme } from "@material-ui/core";
import { wellColors } from "@welldigital/components/theming";

export const useStyles = makeStyles((theme: Theme) => {
  return {
    cardContentText: {
      fontSize: 16,
      color: wellColors.elixir[300],
    },
    pageTitle: {
      fontSize: 34,
      fontWeight: 600,
    },
    detailsCard: {
      width: "100%",
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        width: 250,
        margin: theme.spacing(1, 1, 1, 1),
      },
    },

    detailCardsWrapper: {
      marginTop: theme.spacing(3),
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "stretch",
    },
  };
});
